import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Helpers } from "src/app/services/app.helpers";
import * as moment from "moment";

@Component({
  selector: "app-add-social-history",
  templateUrl: "./add-social-history.component.html",
  styleUrls: ["./add-social-history.component.scss"],
})
export class AddSocialHistoryComponent implements OnInit, OnChanges {
  @Input() model: any;
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Output() success: EventEmitter<any> = new EventEmitter<any>();

  form!: FormGroup;
  homeCareOptions!: any[];
  options!: any[];

  get selectedOption() {
    return this.form.get("Observation")?.value || null;
  }

  constructor(private fb: FormBuilder, private translationService: TranslateService) {}

  ngOnInit() {
    this.getAllOptions();
    this.createForm();

    this.translationService.onLangChange.subscribe((x) => {
      this.getAllOptions();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["model"]) this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Observation: [
        (this.model && this.options?.find((x) => x.value === this.model.code?.coding?.[0]?.code)) || "",
        Validators.required,
      ],
      Value: [
        (this.model && this.homeCareOptions?.find((x) => x.value === this.model.valueString)) ||
          this.model?.valueString ||
          "",
        Validators.required,
      ],
      Date: [(this.model && moment(this.model.effectiveDateTime).toDate()) || "", Validators.required],
    });
  }

  getAllOptions() {
    this.homeCareOptions = [
      {
        id: 0,
        name: this.translationService.instant("24h per day"),
        value: this.translationService.instant("24h per day"),
      },
      {
        id: 1,
        name: this.translationService.instant("Partial home care"),
        value: this.translationService.instant("Partial home care"),
      },
      {
        id: 2,
        name: this.translationService.instant("Family care"),
        value: this.translationService.instant("Family care"),
      },
    ];

    this.options = [
      { id: 0, name: this.translationService.instant("Lifestyle"), value: "lifestyle" },
      {
        id: 1,
        name: this.translationService.instant("Specific difficulty in accessing medical services"),
        value: "medServicesAccess",
      },
      { id: 2, name: this.translationService.instant("Social care services received"), value: "socialCareServices" },
      {
        id: 3,
        name: this.translationService.instant("Centre of elderly and disabled persons"),
        value: "elderlyCenter",
      },
      {
        id: 4,
        name: this.translationService.instant("Home care assistance"),
        value: "homeCareAssistance",
      },
      {
        id: 5,
        name: this.translationService.instant("Housing characteristics"),
        value: "houseChars",
      },
      {
        id: 6,
        name: this.translationService.instant("Other"),
        value: "other",
      },
    ];
  }

  onClose() {
    // this.form.reset();
    this.closed.emit();
  }

  save() {
    Helpers.markFormGroupTouched(this.form);
    Helpers.markFormGroupDirty(this.form);

    if (!this.form.valid) {
      return;
    }

    let procedureSocialHistoryModel: any = {};

    procedureSocialHistoryModel["resourceType"] = "Observation";
    procedureSocialHistoryModel["status"] = "final";
    procedureSocialHistoryModel["code"] = [
      {
        coding: [
          {
            system: "http://clinical.iti.org",
            code: this.form.controls["Observation"].value.value,
            display: this.form.controls["Observation"].value.name,
          },
        ],
        text: this.form.controls["Observation"].value.name,
      },
    ];
    procedureSocialHistoryModel["category"] = [
      {
        coding: [
          {
            system: "http://hl7.org/fhir/observation-category",
            code: "social-history",
            display: "Social History",
          },
        ],
        text: "Social History",
      },
    ];
    procedureSocialHistoryModel["effectiveDateTime"] = moment(this.form.controls["Date"].value).format("YYYY-MM-DD");
    procedureSocialHistoryModel["valueString"] =
      typeof this.form.controls["Value"].value === "string"
        ? this.form.controls["Value"].value
        : this.form.controls["Value"].value.value;

    if (this.model) {
      delete this.model.meta;
      procedureSocialHistoryModel = { ...this.model, ...procedureSocialHistoryModel };
    }

    this.success.emit(procedureSocialHistoryModel);
    this.form.reset();
    this.closed.emit();
  }
}
